__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalHost";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-react", "3.0.7", () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(4536)]).then(() => (() => (__webpack_require__(997))))));
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(639).then(() => (() => (__webpack_require__(639))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))));
			register("react-dom/client", "18.2.0", () => (__webpack_require__.e(5338).then(() => (() => (__webpack_require__(5338))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(1468), __webpack_require__.e(5654)]).then(() => (() => (__webpack_require__(1468))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(1519), __webpack_require__.e(668), __webpack_require__.e(275)]).then(() => (() => (__webpack_require__(1519))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(1574), __webpack_require__.e(668), __webpack_require__.e(2835)]).then(() => (() => (__webpack_require__(1574))))));
			register("react", "18.2.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))));
			register("redux", "5.0.1", () => (() => (__webpack_require__(4644))), 1);
			initExternal(2684);
			initExternal(7883);
			initExternal(121);
			initExternal(6329);
			initExternal(2034);
			initExternal(6583);
			initExternal(7839);
			initExternal(4037);
			initExternal(9761);
			initExternal(7774);
			initExternal(5388);
			initExternal(7685);
			initExternal(8799);
			initExternal(2407);
			initExternal(3267);
			initExternal(780);
			initExternal(1601);
			initExternal(4663);
			initExternal(5118);
			initExternal(5725);
			initExternal(9811);
			initExternal(1214);
			initExternal(8104);
			initExternal(1196);
			initExternal(7509);
			initExternal(2201);
			initExternal(832);
			initExternal(407);
			initExternal(3236);
			initExternal(2629);
			initExternal(9078);
			initExternal(8940);
			initExternal(7836);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};